import { graphql } from 'react-relay';

export const infoLinkFragment = graphql`
    fragment InfoLink_infoLink on InfoLink {
        header
        infotext
        url
        linktext
        key
    }
`;
